import {Dropdown} from "react-bootstrap";
import {twMerge} from "tailwind-merge";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import OptionsIcon from "../../../images/icons/optionsIcon";
import {bancApi} from "../../../services/technicianService";
import {showToastModal} from "../shared/ToastModalSwal";

const BancDropDown = ({
  selected,
  setSelectedBanc,
  banc,
  className,
  setOpenViewMod,
}) => {
  const {onUpdateBanc, onDeleteBanc} = useUpdateTechnician();

  const selectAsDefault = () => {
    onUpdateBanc(
      {body: {isSelected: true}, id: banc.id},
      {
        onSuccess: async () => {
          try {
            const result = await bancApi.startConnectOnboarding(
              "bank_account_update",
            );
            if (!result?.url) {
              throw new Error("Stripe n'a pas renvoyé de lien de vérification.");
            }
            window.location.assign(result.url);
          } catch (error) {
            showToastModal({
              success: false,
              title: "Vérification Stripe",
              message: error?.response?.data?.error
                || error?.message
                || "Impossible d'ouvrir la vérification Stripe.",
            });
          }
        },
      },
    );
  };

  return (
    <Dropdown
      onClick={(e) => {
        // e.stopPropagation();
      }}
      as="li"
      className={twMerge("nav-item dropdown header-profile", className)}
    >
      <Dropdown.Toggle variant="" as="a" className="nav-link i-false">
        {/* <img src={profile} width={20} alt="profile" /> */}
        <OptionsIcon
          className={`w-5 h-5 z-20 absolute top-0 right-0 cursor-pointer  ${
            selected ? "fill-[#1A64B9]" : "fill-[#1A64B9]"
          } `}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu align="right" className="mt-2 ">
        <Dropdown.Item
          className="dropdown-item ai-icon cursor-pointer"
          onClick={() => {
            setSelectedBanc(banc);
            setOpenViewMod(true);
          }}
        >
          <span className="ml-2">Voir </span>
        </Dropdown.Item>

        {!banc.isSelected && (
          <>
            <Dropdown.Item
              className="dropdown-item ai-icon cursor-pointer"
              onClick={selectAsDefault}
            >
              <span className="ml-2">Définir par défaut </span>
            </Dropdown.Item>

            <Dropdown.Item
              className="dropdown-item ai-icon cursor-pointer"
              onClick={() => onDeleteBanc(banc.id)}
            >
              <span className="ml-2">Supprimer </span>
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default BancDropDown;
